<template>
  <v-dialog v-model="show" persistent class="login-dialog" max-width="500px">
    <v-card color="lightPrimary pt-5">
      <v-card-title
        class="text-h5 text-center title-login-dialog primary--text d-flex align-center justify-center"
        >Complete seu cadastro</v-card-title
      >
      <v-card-text class="d-flex flex-column align-center justify-center text-center mt-3 pb-0">
        <p class="gray--text">
          Para agendar uma consulta precisamos que você informe um contato de emergência. Só
          entraremos em contato com essa pessoa em caso de urgência.
        </p>
        <v-form v-model="valid" ref="form" class="full-width">
          <v-container>
            <v-text-field
              solo
              flat
              label="Nome"
              v-model="contact_name"
              :rules="rules"
              required
              background-color="#F7F7F7"
            ></v-text-field>
            <v-text-field
              solo
              flat
              label="Email"
              v-model="contact_email"
              :rules="emailRules"
              required
              background-color="#F7F7F7"
            ></v-text-field>
            <v-row no-gutters>
              <v-col class="col-4 pr-2">
                <CountryCodeSelect
                  :value="phoneCountry"
                  :countries="allPhoneCountries"
                  @input="onPhoneCountryChange"
                />
              </v-col>
              <v-col class="col-8">
                <v-text-field
                  :key="phoneCountry"
                  solo
                  flat
                  label="Telefone"
                  :value="contact_telephone"
                  @input="onPhoneInput"
                  type="tel"
                  :rules="phoneRules"
                  required
                  background-color="#F7F7F7"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="flex-row justify-space-around">
        <v-btn text @click="close" class="mt-2"> Cancelar </v-btn>
        <v-btn large color="secondary" @click="save" :loading="loader" :disabled="!valid">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { AsYouType, isValidPhoneNumber, getCountryCallingCode } from 'libphonenumber-js';
import { editProfile } from '../services/patients';
import CountryCodeSelect from './CountryCodeSelect';
import {
  getAllPhoneCountries,
  getDefaultPhoneCountry,
  parsePhoneValueFull,
} from '../utils/phoneCountriesFull';
import getLanguage from '../utils/getLanguage';

const defaultPhoneCountry = getDefaultPhoneCountry(getLanguage(window.location.href));

export default {
  name: 'ModalContatoEmergencial',
  components: {
    CountryCodeSelect,
  },
  props: {
    isDialogOpen: {
      type: Boolean,
      default: false,
    },
    patientId: {
      type: [String, Number],
      required: true,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      valid: false,
      loader: false,
      contact_name: '',
      contact_email: '',
      contact_telephone: '',
      phoneCountry: defaultPhoneCountry,
      allPhoneCountries: getAllPhoneCountries(),
      rules: [(v) => !!v || 'Esse campo é obrigatório'],
      emailRules: [
        (v) => !!v || 'Esse campo é obrigatório',
        (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email inválido',
      ],
    };
  },
  computed: {
    show: {
      get() {
        return this.isDialogOpen;
      },
      set() {},
    },

    phoneRules() {
      return [
        (v) => !!v || 'Esse campo é obrigatório',
        (v) => isValidPhoneNumber(v || '', this.phoneCountry) || 'Número de telefone inválido',
      ];
    },
  },
  watch: {
    isDialogOpen(val) {
      if (val) {
        this.loadInitialData();
      }
    },
  },
  methods: {
    loadInitialData() {
      this.contact_name = this.initialData.contact_name || '';
      this.contact_email = this.initialData.contact_email || '';
      const parsedPhone = parsePhoneValueFull(
        this.initialData.contact_telephone,
        defaultPhoneCountry,
      );
      this.phoneCountry = parsedPhone.countryCode;
      this.contact_telephone = parsedPhone.phone;
    },
    onPhoneCountryChange(code) {
      this.phoneCountry = code;
      this.contact_telephone = '';
    },
    onPhoneInput(value) {
      const digits = value.replace(/\D/g, '');
      this.contact_telephone = new AsYouType(this.phoneCountry).input(digits);
    },
    close() {
      this.$emit('close');
    },
    async save() {
      if (!this.$refs.form.validate()) return;
      this.loader = true;
      try {
        const updatedPatient = await editProfile(this.patientId, {
          contact_name: this.contact_name,
          contact_email: this.contact_email,
          contact_telephone: `+${getCountryCallingCode(this.phoneCountry)} ${
            this.contact_telephone
          }`,
        });
        this.$emit('saved', updatedPatient);
      } catch (error) {
        this.$showSnackbar('Erro ao salvar contato de emergência. Tente novamente.');
      } finally {
        this.loader = false;
      }
    },
  },
};
</script>

<style lang="css" scoped>
* >>> .v-dialog {
  box-shadow: none !important;
}

.title-login-dialog {
  word-break: break-word;
}

.full-width {
  width: 100%;
}
</style>
